import type { IProgram } from '../types.js';

/** Super visa for parents and grandparents (stays of up to 5 years at a time). */
export const SUPER_VISA: IProgram = {
  id: 'super-visa',
  name: 'Super visa for parents and grandparents',
  short: 'Super visa',
  family: 'temporary',
  status: 'active',
  version: '2026-10-04',
  review: 'pending',
  sources: [
    { title: 'IRCC: Super visa, forms and documents', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada/parent-grandparent-super-visa/forms-documents.html', retrieved: '2026-10-04' },
    { title: 'IRCC: Super visa, who can apply', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada/parent-grandparent-super-visa/eligibility.html', retrieved: '2026-10-04' }
  ],
  questions: [
    { id: 'coSigner', text: 'Does the host\'s spouse or common-law partner co-sign the letter of invitation?', kind: 'yesno' }
  ],
  roles: [
    { id: 'host', label: 'Host (child or grandchild in Canada)', min: 1, max: 1 },
    { id: 'principal', label: 'Parent or grandparent applying', min: 1, max: 2 }
  ],
  sections: ['Host', 'Applicant', 'Fees'],
  items: [
    { id: 'invitation', label: 'Letter of invitation from the host, with the family size and each person\'s name and date of birth', section: 'Host', forRoles: 'application', source: 0 },
    { id: 'hostIncome', label: 'Proof the host meets the minimum necessary income', section: 'Host', forRoles: ['host'], source: 0 },
    { id: 'coSignerIncome', label: 'Co-signer\'s proof of status and income', section: 'Host', forRoles: 'application', when: { q: 'coSigner', is: true }, source: 0 },
    { id: 'hostStatus', label: 'Proof the host is a Canadian citizen, permanent resident or registered Indian', section: 'Host', forRoles: ['host'], source: 0 },
    { id: 'relationship', label: 'Proof of the relationship to the host (host\'s birth or baptismal certificate)', section: 'Host', forRoles: 'application', source: 0, translationIfNotEnFr: true },
    { id: 'insurance', label: 'Private health insurance: at least 1 year from entry, $100,000 emergency coverage, paid (not a quote), from an eligible insurer', section: 'Applicant', forRoles: ['principal'], source: 0 },
    { id: 'medical', label: 'Proof of the immigration medical exam with a panel physician', section: 'Applicant', forRoles: ['principal'], source: 0 },
    { id: 'passport', label: 'Passport', section: 'Applicant', forRoles: ['principal'], source: 1 },
    { id: 'visaOffice', label: 'Documents the local visa office asks for (by country of residence)', section: 'Applicant', forRoles: 'application', source: 0 },
    { id: 'imm5476', label: 'Use of a Representative', form: 'IMM 5476', section: 'Applicant', forRoles: 'application', source: 0 },
    { id: 'translations', label: 'Translations of documents not in English or French', section: 'Applicant', forRoles: 'application', source: 0 },
    { id: 'fees', label: 'Proof of payment of the fees', section: 'Fees', forRoles: 'application', source: 0 }
  ],
  deadlines: []
};
